// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@awc/App/SharedStyles/CartLineSharedStyles";
import { rfqQuoteDetailsRequestedDetailsGridStyles } from "@awc/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsRequestedDetailsGrid";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { mergeWithCss, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

rfqQuoteDetailsRequestedDetailsGridStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};
rfqQuoteDetailsRequestedDetailsGridStyles.productImage = {
    ...mergeWithCss(cartLineSharedStyles.productImage, {
        linkWrappingImage: {
            css: css`
                ${xScreen("lte", "sm")} {
                    width: 114px;
                    height: 114px;
                }
            `,
        },
    }),
};
rfqQuoteDetailsRequestedDetailsGridStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};
rfqQuoteDetailsRequestedDetailsGridStyles.extendedUnitNetPriceText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};
rfqQuoteDetailsRequestedDetailsGridStyles.productPrice = {
    ...mergeWithCss(cartLineSharedStyles.productPrice, {
        priceLabelText: {
            css: css`
                ${xScreen("lte", "md")} {
                    display: none;
                }
            `,
        },
    }),
};

rfqQuoteDetailsRequestedDetailsGridStyles.spinnerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        height: 300px;
        width: 100%;
    `,
};

rfqQuoteDetailsRequestedDetailsGridStyles.costCodeGridItem = {
    width: 6,
    css: css`
        flex-direction: column;
    `,
};

rfqQuoteDetailsRequestedDetailsGridStyles.costCodeLabelText = {
    weight: "bold",
    css: css`
        margin-bottom: 10px;
        margin-right: 10px;
    `,
};

rfqQuoteDetailsRequestedDetailsGridStyles.footerWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-end;
        margin-top: 20px;
        @media print {
            display: block;
        }
    `,
};

rfqQuoteDetailsRequestedDetailsGridStyles.cartLineContainerStyles = {
    container: {
        css: css`
            grid-template-columns: 2fr 7fr 1fr 1fr 1fr;
            ${xScreen("lte", "lg")} {
                grid-template-columns: 2fr 7fr 1fr 1fr 1fr;
            }
            ${xScreen("lte", "md")} {
                grid-template-columns: 1fr 5fr 2fr;
                row-gap: 0;
            }
        `,
    },
    image: {
        css: css`
            display: flex;
            justify-content: center;
            ${xScreen("lte", "md")} {
                grid-column: 1 / 2;
                grid-row: 1 / 5;
            }
        `,
    },
    description: {
        css: css`
            grid-column: 2 / 3;
            ${xScreen("lte", "sm")} {
                grid-column: 2 / 4;
                grid-row: 1 / 2;
            }
        `,
    },
    price: {
        css: css`
            grid-column: 2 / 3;
            grid-row: 2 / 3;
            ${xScreen("lte", "md")} {
                grid-column: 2 / 3;
                grid-row: 2 / 3;
            }
            ${xScreen("lte", "sm")} {
                grid-column: 2 / 4;
                grid-row: 2 / 3;
                text-align: left;
            }
        `,
    },
    qty: {
        css: css`
            grid-column: 4/5;
            grid-row: 2/3;
            text-align: left;
            ${xScreen("lte", "md")} {
                grid-column: 2 / 3;
                grid-row: 2 / 3;
                text-align: right;
            }
            ${xScreen("lte", "sm")} {
                grid-column: 2 / 4;
                grid-row: 3 / 4;
                text-align: left;
            }
        `,
    },
    total: {
        css: css`
            grid-column: 5/6;
            grid-row: 2/3;
            ${xScreen("lte", "md")} {
                grid-column: 3 / 4;
                grid-row: 2 / 3;
            }
            ${xScreen("lte", "sm")} {
                grid-column: 2/4;
                grid-row: 4 / 5;
            }
        `,
    },
    notes: {
        css: css`
            grid-column: 2/3;
            grid-row: 2/3;
            ${xScreen("lte", "md")} {
                grid-row: 3/4;
            }
            ${xScreen("lte", "sm")} {
                grid-column: 1/4;
                grid-row: 5/6;
            }
        `,
    },
};

rfqQuoteDetailsRequestedDetailsGridStyles.qtyOrderedField = {
    qtyLabel: {
        color: "secondary",
        lineHeight: fontConfig.lineHeight.small,
    },
};

rfqQuoteDetailsRequestedDetailsGridStyles.mainWrapper = {
    css: css`
        ${xScreen("lte", "md")} {
            margin-top: 16px;
        }
    `,
};
